/* TAPS About kinetic engine — Direction A (mock: page-lab/about-revamp-layout.html).
   Same kinetic language as the quiz page: pre-paint gate (.ak-js, released here),
   headline word mask-rise, rise staggers, elastic punch-ins (CSS transitions freed
   by ScrollTrigger class toggles), mono boot flickers, mentor meter fill.
   Reduced motion: everything visible, no motion (CSS contract; JS strips the gate). */
(function () {
  "use strict";

  /* wrap each word of the H1 in an overflow-hidden sleeve (.ak-w > i) */
  function splitWords(el) {
    var walk = function (node) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement("span");
            w.className = "ak-w";
            var i = document.createElement("i");
            i.textContent = part;
            w.appendChild(i);
            frag.appendChild(w);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }

  function boot(root) {
    if (!root || root.__ak) return;
    root.__ak = true;

    var reduced = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) { root.classList.remove("ak-js"); return; }

    var g = window.gsap;
    if (!g) { root.classList.remove("ak-js"); return; }
    var ST = window.ScrollTrigger;
    if (ST) { try { g.registerPlugin(ST); } catch (e) {} }

    /* ---- hero entrance: pill rise -> word mask-rise -> sub -> CTA row ---- */
    var h1 = root.querySelector(".ak-h1");
    if (h1 && !h1.__akSplit) { h1.__akSplit = true; splitWords(h1); }
    var words = root.querySelectorAll(".ak-w i");

    var tl = g.timeline({ defaults: { ease: "power4.out" } });
    var pill = root.querySelector(".ak-pill");
    if (pill) tl.to(pill, { opacity: 1, y: 0, duration: 0.6 }, 0.05);
    if (words.length) tl.to(words, { y: 0, duration: 0.85, stagger: 0.045 }, 0.12);
    var sub = root.querySelector(".ak-sub");
    if (sub) tl.to(sub, { opacity: 1, y: 0, duration: 0.7 }, 0.42);
    var cta = root.querySelector(".ak-cta-row");
    if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.7 }, 0.56);

    /* ---- scroll reveals: rise / elastic punch / strip boot-flicker ----
       hidden "from" states live in CSS under .ak-js; releasing = adding .ak-in */
    function show(el) {
      var d = parseInt(el.getAttribute("data-ak-delay") || "0", 10);
      if (d) el.style.transitionDelay = d + "ms";
      el.classList.add("ak-in");
    }
    var reveals = root.querySelectorAll("[data-ak-reveal]");
    if (ST) {
      reveals.forEach(function (el) {
        ST.create({ trigger: el, start: "top 88%", once: true, onEnter: function () { show(el); } });
        /* already in view on load */
        if (el.getBoundingClientRect().top < window.innerHeight * 0.88) show(el);
      });
    } else {
      reveals.forEach(show);
    }

    /* ---- mentor meter: segments light one by one ---- */
    var meter = root.querySelector(".ak-meter");
    function fillMeter() {
      if (!meter || meter.__akFilled) return;
      meter.__akFilled = true;
      var segs = meter.querySelectorAll("i");
      segs.forEach(function (s, i) {
        setTimeout(function () { s.classList.add("ak-on"); }, 300 + i * 90);
      });
    }
    if (meter) {
      if (ST) {
        ST.create({ trigger: meter, start: "top 90%", once: true, onEnter: fillMeter });
        if (meter.getBoundingClientRect().top < window.innerHeight * 0.9) fillMeter();
      } else {
        fillMeter();
      }
    }
  }

  function init() {
    document.querySelectorAll("[data-ak-root]").forEach(boot);
  }

  window.AK = window.AK || {};
  window.AK.init = init;
  window.AK.boot = boot;

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
